import ViewOnlyIngredient from "components/foodDetails/share/ViewOnlyIngredient"
import { FoodListDivider } from "components/foodItem/FoodListItem/styled"
import { IngredientType } from "model/food/types"

import styled from "styled-components"

export const IngredientList = styled.div``

export const IngredientListTitle = styled.div`
  font-size: 14px;
  font-weight: 700;
  line-height: 160%;
  margin-bottom: 8px;
`

const MealIngredients = ({
  ingredients,
  isManualNutrition,
}: {
  ingredients: IngredientType[]
  isManualNutrition?: boolean
}) => {
  return (
    <IngredientList>
      <IngredientListTitle>Ingredients</IngredientListTitle>{" "}
      {ingredients.map((ingredient, index) => (
        <div key={index}>
          <ViewOnlyIngredient ingredient={ingredient} isManualNutrition={isManualNutrition} />
          {index !== ingredients.length && <FoodListDivider />}
        </div>
      ))}
    </IngredientList>
  )
}

export default MealIngredients
